import { Shadows } from '@mui/material/styles';

// Constrói array completo com 25 sombras
const customShadows = Array(25).fill('none') as Shadows;
customShadows[0] = 'none';
customShadows[1] = '0px 2px 8px rgba(0, 0, 0, 0.15)';
customShadows[2] = '0px 4px 12px rgba(0, 0, 0, 0.2)';
customShadows[3] = '0px 6px 20px rgba(0, 0, 0, 0.25)';
customShadows[4] = '0px 8px 28px rgba(0, 0, 0, 0.3)';
customShadows[8] = '0px 12px 40px rgba(0, 0, 0, 0.35)';

export const shadows = customShadows;
export const glow = {
  primary: '0 0 15px rgba(42, 81, 247, 0.35)',
  success: '0 0 15px rgba(16, 185, 129, 0.3)',
  error: '0 0 15px rgba(239, 68, 68, 0.3)',
};
